import { DataGrid, type DataGridColumn } from '@/components/tables/DataGrid';
import { formatDateTime } from '@/utils/format';
import type { StatementCommentDto } from '@/api/types/providerStatements';

interface Props {
  title: string;
  comments: StatementCommentDto[];
  loading?: boolean;
  onClose: () => void;
}

// The audit-trail panel shown inline when the "+" action on a row is clicked. A
// 4-col table (Date / User / Action / Comment) with per-column search (all but Date).
export function StatementCommentsPanel({ title, comments, loading, onClose }: Props) {
  const columns: DataGridColumn<StatementCommentDto>[] = [
    {
      key: 'date',
      title: 'Date',
      className: 'text-start',
      filterable: false,
      value: (r) => r.date,
      cell: (r) => formatDateTime(r.date),
    },
    { key: 'user', title: 'User', className: 'text-start', value: (r) => r.user },
    { key: 'action', title: 'Action', className: 'text-start', value: (r) => r.action },
    { key: 'comment', title: 'Comment', className: 'text-start', value: (r) => r.comment },
  ];

  return (
    <div className="card custom-card mb-0 mt-3">
      <div className="card-header border-bottom d-flex align-items-center justify-content-between">
        <h6 className="card-title mb-0">{title}</h6>
        <button type="button" className="btn btn-sm btn-light" onClick={onClose}>
          <i className="fa fa-times me-1" />
          Close
        </button>
      </div>
      <div className="card-body p-0">
        <DataGrid
          columns={columns}
          data={comments}
          rowKey={(r) => `${r.date}-${r.action}-${r.comment}`}
          columnSearch
          columnVisibilityToggle={false}
          emptyMessage={loading ? 'Loading…' : 'No comments.'}
        />
      </div>
    </div>
  );
}
